export interface AccentPaletteColor {
  name: string;
  /** Swatch/stroke color, also used as the persisted `accentColor` value. */
  accent: string;
  /** Light tint used for card and icon backgrounds. */
  bg: string;
}

/**
 * Shared accent color options for agent avatars, dataset cards, and project cards.
 * `bg` references a CSS var with light/dark variants (see mds-theme.css) so tints
 * adapt to dark mode; the fallback hex covers pages outside the nextgen theme scope.
 */
export const ACCENT_PALETTE: AccentPaletteColor[] = [
  { name: "Blue", accent: "#0173B2", bg: "var(--accent-blue-bg, #E0EEF6)" },
  { name: "Orange", accent: "#DE8F05", bg: "var(--accent-orange-bg, #FBF0DA)" },
  { name: "Green", accent: "#029E73", bg: "var(--accent-green-bg, #DBF3EC)" },
  { name: "Pink", accent: "#CC78BC", bg: "var(--accent-pink-bg, #F7E9F4)" },
  { name: "Gray", accent: "#212121", bg: "var(--accent-gray-bg, #E0E0E0)" },
];

export const DEFAULT_ACCENT_COLOR = ACCENT_PALETTE[0];

export const resolveAccentPaletteColor = (accentColor?: string): AccentPaletteColor =>
  ACCENT_PALETTE.find((c) => c.accent.toLowerCase() === accentColor?.toLowerCase()) ??
  DEFAULT_ACCENT_COLOR;
